import React from 'react'
import { Button, Input } from '../../StyledComponents'
import { IconInfoBlue } from '../../Icons'

interface GatewayInfo {
    sn: string
    callsign: string
    online: boolean
}

interface DroneStationCreatePanelProps {
    name: string
    onNameChange: (value: string) => void
    selectedGatewaySn: string
    onGatewayChange: (value: string) => void
    availableGateways?: GatewayInfo[]
    latitude: string
    longitude: string
    onLatitudeChange: (value: string) => void
    onLongitudeChange: (value: string) => void
    basePrice: number
    decisionFee: number
    applicationFee: number
    onBasePriceChange: (value: string) => void
    onDecisionFeeChange: (value: string) => void
    onApplicationFeeChange: (value: string) => void
    onCancel: () => void
    onSave: () => void
    saveEnabled: boolean
}

export default function DroneStationCreatePanel({
    name,
    onNameChange,
    selectedGatewaySn,
    onGatewayChange,
    availableGateways,
    latitude,
    longitude,
    onLatitudeChange,
    onLongitudeChange,
    basePrice,
    decisionFee,
    applicationFee,
    onBasePriceChange,
    onDecisionFeeChange,
    onApplicationFeeChange,
    onCancel,
    onSave,
    saveEnabled,
}: DroneStationCreatePanelProps) {
    return (
        <div className="min-h-0 flex-1 pb-6">
            <div className="rounded-[20px] border border-[#3B94D2] bg-white px-8 py-7">
                <h2 className="mb-6 text-2xl font-semibold leading-none text-[#3D3D3D]">Neue Drohnenstation hinzufügen</h2>

                <div className="mb-4">
                    <Input
                        label="Name"
                        type="text"
                        value={name}
                        onChange={(value) => onNameChange(String(value))}
                    />
                </div>

                <div className="mb-6 flex flex-col gap-2">
                    <label className="text-sm font-medium text-[#555555]">
                        Drohnenstation (Gateway)
                    </label>
                    {availableGateways && availableGateways.length > 0 ? (
                        <select
                            data-pw="select-gateway-sn"
                            className="h-12 w-full rounded-full border border-[#999999] bg-white px-5 text-base text-[#333333] outline-none"
                            value={selectedGatewaySn}
                            onChange={(event) => onGatewayChange(event.target.value)}
                        >
                            <option value="">Gateway auswählen...</option>
                            {availableGateways.map((gateway) => (
                                <option key={gateway.sn} value={gateway.sn}>
                                    {gateway.callsign} ({gateway.sn}){gateway.online ? ' ✓' : ''}
                                </option>
                            ))}
                        </select>
                    ) : (
                        <div className="rounded-md border border-gray-200 bg-gray-50 p-2 text-sm text-gray-500">
                            Keine verfügbaren Gateways gefunden.
                        </div>
                    )}
                </div>

                <div className="my-6 border-t border-[#9A9A9A]" />

                <div className="mb-4 text-sm text-[#0A67A6] flex gap-2">
                   <IconInfoBlue/> Wähle eine Position auf der Karte aus, um eine Drohnenstation zu konfigurieren.
                </div>

                <div className="mb-6 grid grid-cols-2 gap-4">
                    <Input
                        label="Latitude"
                        type="number"
                        value={latitude}
                        onChange={(value) => onLatitudeChange(String(value))}
                        step={0.0001}
                    />
                    <Input
                        label="Longitude"
                        type="number"
                        value={longitude}
                        onChange={(value) => onLongitudeChange(String(value))}
                        step={0.0001}
                    />
                </div>

                <div className="my-6 border-t border-[#9A9A9A]" />

                <div className="mb-2 text-sm text-[#555555]">Preis & Kosten (€)</div>

                <div className="grid grid-cols-3 gap-4">
                    <Input
                        label="Basispreis"
                        type="number"
                        value={String(basePrice)}
                        onChange={(value) => onBasePriceChange(String(value))}
                    />
                    <Input
                        label="Bescheidbeantragung"
                        type="number"
                        value={String(decisionFee)}
                        onChange={(value) => onDecisionFeeChange(String(value))}
                    />
                    <Input
                        label="Bescheid"
                        type="number"
                        value={String(applicationFee)}
                        onChange={(value) => onApplicationFeeChange(String(value))}
                    />
                </div>
            </div>

            <div className="mt-5 flex items-center justify-end gap-4">
                <Button
                    className="h-12 rounded-full border border-[#E1320F] px-8 text-sm font-semibold text-[#E1320F]"
                    onClick={onCancel}
                >
                    Abbrechen
                </Button>
                <Button
                    className="h-12 rounded-full bg-[#E1320F] px-10 text-sm font-semibold text-white"
                    onClick={onSave}
                    enabled={saveEnabled}
                    primary
                >
                    Speichern
                </Button>
            </div>
        </div>
    )
}
